export const footer = {
	title: 'Billing information',
	id: 'ID',
	taxId: 'Tax ID',
	registration: [
		'Company PaRELI s.r.o. is registered at the Commercial Register,',
		'District Court of Bratislava I, Section: Sro, Insert No. 89945/B',
	],
};
